import React, { Component } from 'react';
import IconsGrid from './IconsGrid/IconsGrid';
import Team from './Team/Team';
import Contact from './Contact/Contact';
import Demos from './Demos/Demos';
import './Body.css';

class Body extends Component {
  state = {};
  render() {
    return (
      <div id="body">
        <IconsGrid />
        <Demos />
        <Team />
        <Contact />
      </div>
    );
  }
}

export default Body;
